namespace GeniuzPOS.Administration {
    export interface PsBizTypesRow {
        Id?: number;
        BizType?: string;
        BizTypeName?: string;
    }

    export namespace PsBizTypesRow {
        export const idProperty = 'BizType';
        export const nameProperty = 'BizTypeName';
        export const localTextPrefix = 'Administration.PsBizTypes';
        export const lookupKey = 'Administration.PsBizTypes';

        export function getLookup(): Q.Lookup<PsBizTypesRow> {
            return Q.getLookup<PsBizTypesRow>('Administration.PsBizTypes');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';

        export declare const enum Fields {
            Id = "Id",
            BizType = "BizType",
            BizTypeName = "BizTypeName"
        }
    }
}
